"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sharedConfigurationContext = exports.SharedConfigurationProvider = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const sharedConfigurationContext = exports.sharedConfigurationContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const {
  Provider
} = sharedConfigurationContext;
const SharedConfigurationProvider = ({
  children,
  value
}) => {
  const {
    originalItemCode,
    originalQuantity,
    isMrpStatementEnabled,
    isRatingsAndReviewsEnabled,
    personalSubscriptionsEnabled
  } = value;
  const [productCode, setProductCode] = (0, _react.useState)(originalItemCode);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: (0, _react.useMemo)(() => ({
      originalItemCode: productCode,
      originalQuantity,
      isMrpStatementEnabled,
      isRatingsAndReviewsEnabled,
      personalSubscriptionsEnabled,
      setOriginalItemCode: setProductCode
    }), [isMrpStatementEnabled, isRatingsAndReviewsEnabled, originalQuantity, personalSubscriptionsEnabled, productCode]),
    children: children
  });
};
exports.SharedConfigurationProvider = SharedConfigurationProvider;